import { render, staticRenderFns } from "./quiz_options.vue?vue&type=template&id=7af2d26f&scoped=true&"
import script from "./quiz_options.vue?vue&type=script&lang=js&"
export * from "./quiz_options.vue?vue&type=script&lang=js&"
import style0 from "./quiz_options.vue?vue&type=style&index=0&id=7af2d26f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2d26f",
  null
  
)

export default component.exports